import { PromotionSlider } from './PromotionSlider.refactored'

export default PromotionSlider
